"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsPolarAnswerWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var services_1 = require("@falcon/services");
var Types_1 = require("../Types");
var core_1 = require("@athena-portal/core");
var ClaimsPolarAnswerWidget = exports.ClaimsPolarAnswerWidget = /** @class */ (function (_super) {
    __extends(ClaimsPolarAnswerWidget, _super);
    function ClaimsPolarAnswerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.driver = _this.getSetting("driver");
        if (!_this.driver) {
            throw Error("".concat(_this.props.question.type, " widget is missing 'driver' setting"));
        }
        _this.isMotorProduct = services_1.productHelper.isMotor(_this.props.interaction);
        _this.isWolfMotorProduct = services_1.productHelper.isWolfMotor(_this.props.interaction);
        _this.isRentersProduct = services_1.productHelper.isRenters(_this.props.interaction);
        var hasReadOnlyClaims = false;
        var readOnlyClaimsNumber = journey_services_1.ObjectManipulator.fetchFieldValue(_this.driver + ".numberOfReadOnlyClaims", _this.props.interaction);
        if (typeof readOnlyClaimsNumber === "number" && readOnlyClaimsNumber > 0) {
            hasReadOnlyClaims = true;
        }
        _this.state = {
            informationHidden: true,
            isPolicyHolder: _this.driver === "policyHolder",
            hasReadOnlyClaims: hasReadOnlyClaims
        };
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        _this.clickInfoButton = _this.clickInfoButton.bind(_this);
        return _this;
    }
    ClaimsPolarAnswerWidget.prototype.render = function () {
        return (React.createElement("div", { className: "form-group ".concat(this.state.informationHidden ? "" : "background-color-grey inner-content negative-margin width-auto pb-2") },
            React.createElement("div", { className: "d-flex justify-content-between align-items-start info-button-start" },
                (this.isMotorProduct || this.isWolfMotorProduct) && (this.state.isPolicyHolder ?
                    React.createElement("label", { className: "claims-and-convictions-label-holder no-wrap-label", htmlFor: this.getSetting("name") },
                        React.createElement("span", { className: "whitespace-normal-span" }, "Have you had any claims or accidents (including while insured with us) in the last 5 years?"),
                        "\u00A0",
                        React.createElement("span", { className: "info-button-container" },
                            React.createElement("div", { className: "info-button ".concat(!this.state.informationHidden ? "selected" : ""), tabIndex: 0, "aria-label": "Toggle additional information", onClick: this.clickInfoButton, onKeyPress: this.clickInfoButton }))) :
                    React.createElement("label", { className: "claims-and-convictions-label no-wrap-label", htmlFor: this.getSetting("name") },
                        React.createElement("span", { className: "whitespace-normal-span" }, "Has the driver had any claims or accidents in the last 5 years?"),
                        "\u00A0",
                        React.createElement("span", { className: "info-button-container" },
                            React.createElement("div", { className: "info-button ".concat(!this.state.informationHidden ? "selected" : ""), tabIndex: 0, "aria-label": "Toggle additional information", onClick: this.clickInfoButton, onKeyPress: this.clickInfoButton })))),
                this.isRentersProduct &&
                    React.createElement("label", { htmlFor: this.getSetting("name") }, "In the last 5 years, have you or anyone living with you made any home insurance claims? ")),
            (this.isMotorProduct || this.isWolfMotorProduct) && !this.state.informationHidden && this.state.isPolicyHolder &&
                React.createElement("div", { className: "info-button-panel", role: "alert" }, "You need to tell us all the details, regardless of whether it was your fault or not, and if you claimed or not."),
            (this.isMotorProduct || this.isWolfMotorProduct) && !this.state.informationHidden && !this.state.isPolicyHolder &&
                React.createElement("div", { className: "info-button-panel", role: "alert" }, "You need to tell us all the details, regardless of whether it was drivers fault or not, and if the driver claimed or not"),
            this.isRentersProduct && !this.state.informationHidden &&
                React.createElement("div", { className: "info-button-panel", role: "alert" }, "We need to know about any buildings and contents claims (at any address) that you've made in the past five years before the date you'd like your policy to start."),
            React.createElement("div", { className: "input-group", role: "group", "aria-label": "Have you had any claims or accidents including while insured with us in the last 5 years?" },
                React.createElement("div", { className: "custom-control custom-radio" },
                    React.createElement("input", { id: "".concat(this.getSetting("name", ""), "-true"), className: "custom-control-input", type: "radio", name: this.getSetting("name"), value: "true", checked: Boolean(this.bindFromField(this.props.question.interactionField)), onChange: this.handleOnChangeEvent }),
                    React.createElement("label", { id: "claims-yes-button", className: "custom-control-label", htmlFor: "".concat(this.getSetting("name", ""), "-true") }, "Yes")),
                React.createElement("div", { className: "custom-control custom-radio" },
                    React.createElement("input", { id: "".concat(this.getSetting("name", ""), "-false"), className: "custom-control-input ".concat(this.state.hasReadOnlyClaims && "disabled"), type: "radio", name: this.getSetting("name"), value: "false", disabled: this.state.hasReadOnlyClaims, checked: this.bindFromField(this.props.question.interactionField) === false || this.bindFromField(this.props.question.interactionField) === "false", onChange: this.handleOnChangeEvent }),
                    React.createElement("label", { id: "claims-no-button", className: "custom-control-label", htmlFor: "".concat(this.getSetting("name", ""), "-false") }, "No")),
                this.validationErrorsPresent() && this.bindFromField(this.props.question.interactionField) === undefined && React.createElement("div", { className: "invalid-feedback d-block" }, "Please answer this to carry on"))));
    };
    ClaimsPolarAnswerWidget.prototype.clickInfoButton = function () {
        this.setState(function (prevState) { return ({
            informationHidden: !prevState.informationHidden
        }); });
    };
    ClaimsPolarAnswerWidget.prototype.handleOnChangeEvent = function (event) {
        var hasClaims = event.target.value === "true";
        if (!hasClaims) {
            this.props.onStateChange(this.driver + ".claims", []);
            this.props.onStateChange(this.driver + ".numberOfClaims", null);
        }
        this.props.onStateChange(this.props.question.interactionField, hasClaims);
        this.changelogRecorder.recordQuestion("change", this.props);
        this.executeNativeEvent(event);
    };
    ClaimsPolarAnswerWidget.prototype.validationErrorsPresent = function () {
        var _this = this;
        return Object.keys(this.props.validations).map(function (key) { return _this.props.validations[key]; }).some(function (v) { return v.valid === false; });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], ClaimsPolarAnswerWidget.prototype, "changelogRecorder", void 0);
    return ClaimsPolarAnswerWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=ClaimsPolarAnswerWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/ClaimsPolarAnswerWidget.js
// module id = 3498
// module chunks = 0